import React, { Dispatch, useState } from 'react'

import CityFibreBanner from './city-fibre'
import { IntersectionPoint } from './intersection-point'
import Ms3Banner from './ms3'

interface FilterBannerProps {
  postcode: string
  setFilter: (filter: string) => void
  showMs3Banner?: boolean
  isCityFibreTrial?: boolean
  forceIntersection?: boolean
  showBannerButton?: boolean
  setShowBannerButton: Dispatch<void>
}

const FilterBanner: React.FC<FilterBannerProps> = ({
  postcode,
  setFilter,
  showMs3Banner = false,
  isCityFibreTrial = false,
  forceIntersection = false,
  showBannerButton,
  setShowBannerButton
}) => {
  const [isIntersecting, setIsIntersecting] = useState(true)
  const DISTANCE_TO_TABLE = 300
  const TABLE_TOP_OFFSET = 100

  const bannerToShow = isCityFibreTrial ? 'city-fibre' : showMs3Banner ? 'ms3' : false
  if (!bannerToShow) return null

  return (
    <>
      <IntersectionPoint setIsVisible={setIsIntersecting} />

      {bannerToShow === 'city-fibre' && (
        <CityFibreBanner
          isIntersecting={isIntersecting || forceIntersection}
          setIsIntersecting={setIsIntersecting}
          postcode={postcode}
          setFilter={setFilter}
          distanceToTable={DISTANCE_TO_TABLE}
          tableTopOffset={TABLE_TOP_OFFSET}
          showBannerButton={showBannerButton}
          setShowBannerButton={setShowBannerButton}
        />
      )}

      {bannerToShow === 'ms3' && (
        <Ms3Banner
          isIntersecting={isIntersecting || forceIntersection}
          setIsIntersecting={setIsIntersecting}
          postcode={postcode}
          setFilter={setFilter}
          distanceToTable={DISTANCE_TO_TABLE}
          tableTopOffset={TABLE_TOP_OFFSET}
        />
      )}
    </>
  )
}

export default FilterBanner
